import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../../../../design-system/index.js";
import { cn } from "../../../../design-system/index.js";

export default function CallToActionSection() {
  return (
    <section
      id="segundoChamado"
      className={cn(
        "relative overflow-hidden bg-gradient-to-br",
        "from-[var(--color-rose-400)] to-[#d4736a] py-16 sm:py-20"
      )}
    >
      {/* Blob decorativo */}
      <div className="pointer-events-none absolute -top-16 -right-16 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-12 -left-12 h-48 w-48 rounded-full bg-white/10 blur-2xl" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 text-center">
        <h2 className={cn(
          "font-heading text-3xl sm:text-4xl font-bold",
          "text-white mb-4"
        )}>
          Comece Hoje Mesmo!
        </h2>
        <p className={cn(
          "text-white/80 text-base sm:text-lg mb-8",
          "max-w-md mx-auto"
        )}>
          Encontre a babá perfeita para seu tesourinho. Cadastro rápido, seguro e gratuito.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <Button
            variant="secondary"
            size="lg"
            className={cn(
              "rounded-full bg-white px-7 py-3 font-bold",
              "text-[var(--color-rose-400)] shadow-lg",
              "hover:shadow-xl hover:-translate-y-0.5 transition-all"
            )}
            asChild
          >
            <Link to="/auth-options" className="inline-flex items-center gap-2 whitespace-nowrap leading-none">
              <span>Faça parte agora</span>
              <ArrowRight size={16} className="shrink-0" />
            </Link>
          </Button>
          <Button
            variant="ghost"
            size="lg"
            className={cn(
              "rounded-full border-2 border-white/60 px-7 py-3 font-bold",
              "text-white hover:bg-white/10"
            )}
            asChild
          >
            <Link to="/login">
              Já tenho conta
            </Link>
          </Button>
        </div>

        <img
          src="/assets/bebe.webp"
          alt="Bebê feliz"
          className="mx-auto mt-8 h-32 sm:h-40 w-auto object-contain drop-shadow-lg"
        />
      </div>
    </section>
  );
}